import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import CDN from "@/ts/Utility/CDN";
import {onMounted, onUnmounted, ref} from "vue";
import ImageViewer from "@/ts/ImageViewer/ImageViewer";


export default /*@__PURE__*/_defineComponent({
  __name: 'ImageViewer',
  setup(__props) {

const container = ref<HTMLDivElement>( )
const image = ref<HTMLImageElement>( )
const log = ref<string>("")
const closing = ref<boolean>(false)
const viewer = ImageViewer.getInstance()
const init = () => {
  viewer.init(container.value!,image.value!)
}
onMounted(() => {
  init()
})
onUnmounted(() => {
  viewer.destroy()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "image-viewer",
    ref_key: "container",
    ref: container
  }, [
    _createElementVNode("img", {
      alt: "image",
      ref_key: "image",
      ref: image
    }, null, 512)
  ], 512))
}
}

})